module.exports = __webpack_public_path__ + "static/media/coca-cola.440ebd0f.png";